module.exports = __webpack_public_path__ + "6b6c1950253fb409dc5672b42f8d0f4a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/green-powder.jpg
 ** module id = 194
 ** module chunks = 0
 **/